import { TeamCard } from './teamCard';
import { TbBrandTelegram, TbBrandTwitter, TbWorld } from 'react-icons/tb';
import { useState } from 'react';
import { shortenAddress } from '../../../helpers/address';
import { getSupportedChain } from '../../../helpers/getSupportedChain';
import { getTokenName } from '../../../helpers/getChainName';
import Link from 'next/link';
import { mdParser } from '../../markdown/mdRender';

export const CollectionInfoDetails = ({ collection }) => {
  const [member, setMember] = useState(
    collection?.collectionInfoLookup
      ?.filter((c) => c?.key === 'collection_team')
      ?.map((c) => ({
        id: c?.id,
        name: c?.name,
        title: c?.other.title,
        description: c?.description,
        walletAddress: c?.other.walletAddress,
      })),
  );
  const [existMember, setExistMember] = useState(false);
  useState(() => {
    if (member && member.length > 0) {
      setExistMember(true);
    } else {
      setExistMember(false);
    }
  }, [member]);

  const about = collection?.collectionInfoLookup
    ?.filter((c) => c?.key === 'collection_about')
    ?.map((c) => ({
      id: c?.id,
      name: c?.name,
      description: c?.description,
    }))?.[0];
  const bodyParsed = mdParser.render(about?.description ?? '');
  const [existDescription, setExistDescription] = useState(false);
  useState(() => {
    if (about?.description) {
      setExistDescription(true);
    } else {
      setExistDescription(false);
    }
  }, [about?.description]);

  return (
    <div>
      <div className='flex flex-col gap-10 sm:flex-row'>
        <div className='inline-flex flex-col gap-6 sm:w-[60%]'>
          <Title text={`About ${collection?.name}`} />
          {existDescription ? (
            <div
              className='custom-html-style mb-10 mt-4 text-[14px] text-[#000] dark:text-white'
              dangerouslySetInnerHTML={{ __html: bodyParsed }}
            />
          ) : (
            <div>
              <span className='text-sm font-semibold text-jacarta-900 dark:text-jacarta-100'>
                There is no information about this collection yet.
              </span>
            </div>
          )}
        </div>
        <div className='inline-flex flex-col flex-wrap gap-6 sm:w-[50%]'>
          <Title text='Team' />
          {existMember ? (
            <div className='flex flex-wrap justify-start gap-1 md:gap-3'>
              {member.map((member, index) => (
                <TeamCard key={index} {...member} />
              ))}
            </div>
          ) : (
            <div>
              <span className='text-sm font-semibold text-jacarta-900 dark:text-jacarta-100'>
                There is no team information for this collection yet.
              </span>
            </div>
          )}
          <Title text='Contract' />
          <div className='rounded-2.5xl w-full border border-jacarta-100 bg-white p-3 dark:border-jacarta-700 dark:bg-jacarta-700'>
            <div className='flex justify-between'>
              <span className='font-semibold text-jacarta-800 dark:text-jacarta-100'>
                Contract Address
              </span>
              <Link
                href={`${getSupportedChain(collection?.chain)?.scan_url}/address/${
                  collection?.address
                }`}
              >
                <a className='ml-1 flex items-center text-sm font-bold text-accent' target='_blank'>
                  <span className='mr-1.5 text-sm font-bold'>
                    {shortenAddress(collection?.address ?? '')}
                  </span>
                </a>
              </Link>
            </div>
            <div className='flex justify-between'>
              <span className='font-semibold text-jacarta-800 dark:text-jacarta-100'>
                Token Standard
              </span>
              <span className='text-sm'>{collection.contractType}</span>
            </div>
            <div className='flex justify-between'>
              <span className='font-semibold text-jacarta-800 dark:text-jacarta-100'>Items</span>
              <span className='text-sm'>1</span>
            </div>
            <div className='flex justify-between'>
              <span className='font-semibold text-jacarta-800 dark:text-jacarta-100'>Chain</span>
              <span className='text-sm'>{getTokenName(collection?.chain)}</span>
            </div>
          </div>
          <Title text='Links' />
          <div className='rounded-2.5xl w-fit flex-col justify-between gap-3 border border-jacarta-100 bg-white px-5 py-3 dark:border-jacarta-700 dark:bg-jacarta-700'>
            {collection?.website && (
              <div className='flex items-center gap-2'>
                <TbWorld />
                <Link href={collection?.website} className='no-underline'>
                  <a target='_blank'>
                    <span className='text-sm'>Website</span>
                  </a>
                </Link>
              </div>
            )}
            {collection?.twitter && (
              <div className='flex gap-2'>
                <TbBrandTwitter />
                <Link href={collection?.twitter}>
                  <a target='_blank'>
                    <span className='text-sm'>Twitter</span>
                  </a>
                </Link>
              </div>
            )}
            {collection?.telegram && (
              <div className='flex gap-2'>
                <TbBrandTelegram />
                <Link href={collection?.telegram}>
                  <a target='_blank'>
                    <span className='text-sm'>Telegram</span>
                  </a>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Title = ({ text }) => (
  <span className='text-xl font-semibold text-jacarta-800 dark:text-jacarta-100'>{text}</span>
);

// const Description = ({ text }) => (
//   <div className='flex flex-col items-start gap-4 rounded-large border border-solid border-[#E7E8EC] bg-white px-6 py-3 text-[18px] font-normal leading-6 text-[#000] dark:border-jacarta-600 dark:bg-jacarta-800 dark:text-white'>
//     <span>{text}</span>
//   </div>
// );
